var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"content__text"},[_vm._v("Страница находится в процессе разработки")])])
}]

export { render, staticRenderFns }